<template>
    <div id="shopDetail">
        <template v-if="app.template.type === '92fanli'">
            <NTfanliShopDetail :style-name="app.template.style" :shop-detail="shopDetail"
                               :coupon-list="couponList" :goods-list="goodsList" />
        </template>
        <template v-else-if="app.template.type === 'damai'">
            <DamaiShopDetail :style-name="app.template.style" :shop-detail="shopDetail"
                             :coupon-list="couponList" :goods-list="goodsList" />
        </template>
        <template v-else>
            <IfanliShopDetail :style-name="app.template.style" :shop-detail="shopDetail"
                              :coupon-list="couponList" :goods-list="goodsList" />
        </template>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import {appService} from '../services/app';
    import NTfanliShopDetail from './92fanli/ShopDetail';
    import IfanliShopDetail from './ifanli/ShopDetail';
    import DamaiShopDetail from './damai/ShopDetail';
    import {isMobile} from "../libs/utils";

    export default {
        components: {NTfanliShopDetail, IfanliShopDetail, DamaiShopDetail},
        data() {
            return {
                id: 0,
                tipStatus: false,
                couponList: [],
                goodsList: [],
                tabIndex: 0,
                shopDetail: {
                    shop_icon: '',
                    shop_name: '',
                    credit: '',
                    address: '',
                    total_volume: '',
                    commission_amount_30d: '',
                    evaluates: [],
                    short_url: '',
                    tpwd: ''
                }
            }
        },
        computed: {
            ...mapState(['app'])
        },
        created() {
            this.id = this.$route.query.id;

            if (!isMobile()) {
                window.location.href = window.location.origin + '/shop/detail/' + this.id;
            }

            if (this.id > 0) {
                this.fetchTopShopDetail();
                this.fetchTopShopCouponList();
                this.fetchTopShopGoodsList();
            }
        },
        methods: {
            fetchTopShopDetail: function () {
                let self = this;
                appService.fetchTopShopDetail(self.id).then((res) => {
                    let {code, data} = res;
                    if (code === 200) {
                        self.shopDetail = data;
                        self.shopDetail.evaluates = JSON.parse(self.shopDetail.evaluates);
                    }
                });
            },
            fetchTopShopCouponList: function () {
                let self = this;
                appService.fetchTopShopCouponList(self.id).then((res) => {
                    let {code, data} = res;
                    if (code === 200) {
                        self.couponList = data !== null ? data : [];
                    }
                });
            },
            fetchTopShopGoodsList: function () {
                let self = this;
                appService.fetchTopShopGoodsList(self.id).then((res) => {
                    let {code, data} = res;
                    if (code === 200) {
                        self.goodsList = data !== null ? data : [];
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>
